import type { FaireProductEntity } from "../../entity_types/product";

export const p_f3x8xsqg32: FaireProductEntity = {
  token: "p_f3x8xsqg32",
  type: "product",
  name: "A Liturgy of Grief: A Pastoral Commentary on Lamentations - Paperback",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4ece9c48d6a8048501f18d8999cabab589db8927be8bccc0fd1264d04ad5d4ff.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/bedd00cb97acbbe8d8b5c8925046b321ff87d56eb062475f6fa06bb2c47b1d38.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
